export const NAV_DATA_SOURCE_ELEMENT_TYPES = [
    'text',
    'textarea',
    'number',
    'datetime',
    'time',
    'combobox',
    'autocomplete',
    'radio',
    'combined',
    'position',
];
//# sourceMappingURL=Schema.js.map